import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'

const endpoints = (baseURL => {
  return {
    updateWelcomeSeries: idList =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/workflows/welcomeseries`,
    searchWorkflowByTypeAndStatus: idList =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/workflows`
  }
})(process.env.BEAUTOMATION_URL)

/**
 * @description Update the Welcome Series Automation Workflow.
 * @param {number} idList id of the list where add the template
 * @param {number} idMessage id of the message
 */
export const beAutomationApiUpdateWelcomeSeries = (idList, idMessage) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateWelcomeSeries(idList),
    data: JSON.stringify({ idMessage })
  }).then(extractApiData)
}

/**
 * @description Search workflows by type and status
 * @param {number} idList id of the list where add the template
 * @param {string} data.Status status workwlow
 * @param {string} data.Type type workflow
 */
export const beAutomationApiSearchWorkflowByTypeAndStatus = (idList, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.searchWorkflowByTypeAndStatus(idList),
    data: JSON.stringify(data)
  }).then(extractApiData)
}
